import axios from '../../../axios/index.js';
import store from '../../../../store/store.js';

// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

export function onAccessTokenFetched (access_token) {
    subscribers = subscribers.filter(callback => callback(access_token));
    isAlreadyFetchingAccessToken = false;
}

function addSubscriber (callback) {
    subscribers.push(callback);
}

export default {
    init () {
        axios.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            const {
                config,
                response,
            } = error;
            const originalRequest = config;

            if (response && response.status === 401) {
                if (!isAlreadyFetchingAccessToken) {
                    isAlreadyFetchingAccessToken = true;
                    store.dispatch('auth/fetchAccessToken', { token: localStorage.getItem('refreshToken') })
                        .then((response) => {
                            onAccessTokenFetched(response.data.data.access_token);
                        })
                        .catch(() => {
                            if (window.parent != window) {
                                // we are in iframe, wait for parent to post auth details from zoho
                                window.parent.postMessage('Unauthorized', '*');

                                return new Promise((resolve) => {
                                    addSubscriber(access_token => {
                                        originalRequest.headers.Authorization = 'Bearer ' + access_token;

                                        resolve(axios(originalRequest));
                                    });
                                });
                            } else {
                                localStorage.setItem('returnUrl', window.location.pathname);
                                window.location.href = store.state.AppInfo.auth.login_url;
                            }
                        });
                }

                return new Promise((resolve) => {
                    addSubscriber(access_token => {
                        originalRequest.headers.Authorization = 'Bearer ' + access_token;

                        resolve(axios(originalRequest));
                    });
                });
            }
            return Promise.reject(error);
        });
    },
    login (email, pwd) {
        return axios.post(store.state.AppInfo.auth.api_login_url, {
            email: email,
            password: pwd,
        });
    },
    loginWithToken (token) {
        return axios.post(store.state.AppInfo.auth.api_login_url, { token: token });
    },
    registerUser (name, email, pwd) {
        return axios.post('/api/auth/register', {
            displayName: name,
            email: email,
            password: pwd,
        });
    },
    refreshToken (token) {
        return axios.post(store.state.AppInfo.auth.api_refresh_url, { token: token });
    },
    logoutWithToken (token) {
        return axios.post(store.state.AppInfo.auth.api_logout_url, { token: token });
    },
    loginWithZohoDeskUserEmail (email) {
        return axios.post('/api/v1/auth/loginWithZohoDesk', { email: email });
    },
};
